import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";

const OvertimeBarchart = ({ chartdata, displaychart, selectedRate }) => {
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);
  const { value } = displaychart || {};
  const genderValue = value === "0" ? "both" : Number(value);
  
  useEffect(() => {
    if (!chartdata || chartdata.length === 0) return;

    const years = chartdata.map((d) => String(d.year || ""));
    
    // Determine which rate to use
    const rateField = selectedRate ? selectedRate.value : null;
    let maleDataField = "total_male_cases";
    let femaleDataField = "total_female_cases";
    let seriesName = "Cases";

    if (rateField) {
      switch (rateField.toLowerCase()) {
        case "asr":
          maleDataField = "total_male_asr";
          femaleDataField = "total_female_asr";
          seriesName = "ASR";
          break;
        case "cir":
          maleDataField = "total_male_cir";
          femaleDataField = "total_female_cir";
          seriesName = "CIR";
          break;
        case "cases":
        default:
          maleDataField = "total_male_cases";
          femaleDataField = "total_female_cases";
          seriesName = "Cases";
          break;
      }
    }

    let series = [];

    switch (genderValue) {
      case 1:
        series = [
          {
            name: `Male ${seriesName}`,
            data: chartdata.map((d) => seriesName === "Cases" ? Math.round(d[maleDataField] || 0) : (d[maleDataField] || 0)),
          },
        ];
        break;

      case 2:
        series = [
          {
            name: `Female ${seriesName}`,
            data: chartdata.map((d) => seriesName === "Cases" ? Math.round(d[femaleDataField] || 0) : (d[femaleDataField] || 0)),
          },
        ];
        break;

      case "both":
      default:
        series = [
          {
            name: `Male ${seriesName}`,
            data: chartdata.map((d) => seriesName === "Cases" ? Math.round(d[maleDataField] || 0) : (d[maleDataField] || 0)),
          },
          {
            name: `Female ${seriesName}`,
            data: chartdata.map((d) => seriesName === "Cases" ? Math.round(d[femaleDataField] || 0) : (d[femaleDataField] || 0)),
          },
        ];
        break
    }

    setChartSeries(series);

    // Calculate dynamic min and max values from the data
    let allValues = [];
    series.forEach((s) => {
      allValues = allValues.concat(s.data);
    });
    const minValue = Math.min(...allValues);
    const maxValue = Math.max(...allValues);
    const range = maxValue - minValue;
    const padding = range * 0.1; // 10% padding

    // Get the series name for the x-axis title
    let xAxisTitle = "Number of New Cases";
    if (genderValue === "both") {
      xAxisTitle = `Both ${seriesName}`;
    } else if (genderValue === 1) {
      xAxisTitle = `Male ${seriesName}`;
    } else if (genderValue === 2) {
      xAxisTitle = `Female ${seriesName}`;
    }

    setChartOptions({
      chart: {
        type: "bar",
      },
      xaxis: {
        categories: years,
        title: {
          text: xAxisTitle,
        },
        min: Math.max(0, minValue - padding),
        max: maxValue + padding,
      },
      yaxis: {
        title: {
          text: "Year",
        },
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "100%",
        },
      },
    });
  }, [chartdata, genderValue, selectedRate]);
  return (
    <div>
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="bar"
        width={"100%"}
      />
    </div>
  );
};

export default OvertimeBarchart;
